import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { campInfo } from '../data/mock';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold text-emerald-400 mb-4">
              Kemp Josef
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              Rodinný kemp s přátelskou atmosférou v malebné vinařské oblasti jižní Moravy od roku {campInfo.founded}.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-emerald-400">
              Rychlé odkazy
            </h4>
            <ul className="space-y-2">
              {['O kempu', 'Ubytování', 'Gastronomie', 'Ceník', 'Galerie', 'Kontakt'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase().replace(' ', ''))}
                    className="text-gray-300 hover:text-emerald-400 transition-colors"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-emerald-400">
              Kontakt
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-emerald-400 mt-1 flex-shrink-0" />
                <a
                  href="tel:+420721022279"
                  className="text-gray-300 hover:text-emerald-400 transition-colors"
                >
                  +420 721 022 279
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-emerald-400 mt-1 flex-shrink-0" />
                <a
                  href="mailto:campjosef@seznam.cz"
                  className="text-gray-300 hover:text-emerald-400 transition-colors"
                >
                  campjosef@seznam.cz
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-emerald-400 mt-1 flex-shrink-0" />
                <span className="text-gray-300">
                  {campInfo.location}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-emerald-400">
              Otevírací doba
            </h4>
            <p className="text-gray-300 mb-4">
              Služba 24 hodin denně<br />
              7 dní v týdnu
            </p>
            <p className="text-sm text-emerald-400 font-medium">
              Vždy jsme vám k dispozici!
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Kemp Josef. Všechna práva vyhrazena.
            </p>
            <p className="text-gray-400 text-sm">
              Dubňany, jižní Morava
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
